import React, { useEffect, useRef, useState } from 'react'
import { useParams } from 'react-router-dom';
import { loadSmplrJs } from '@smplrspace/smplr-loader';
import { Box, Typography } from '@mui/material';
import * as d3 from 'd3';
import axios from 'axios';

const IFrameBuildingView = () => {
    const { siteId } = useParams();
    const { key } = useParams();
    const { viewType } = useParams();
    const { renderMode } = useParams();
    const [smplr, setSmplr] = useState()
    const [viewerReady, setViewerReady] = useState(false)
    const [spaceData, setSpaceData] = useState({})
    const [showSpace, setShowSpace] = useState(false)
    const spaceRef = useRef()
    const [noSiteAccess, setNoSiteAccess] = useState(false)
    const [accessDenied, setAccessDenied] = useState(false)

    // Load smplr module 
    useEffect(() => {
        loadSmplrJs('EMS')
          .then((smplr) => {
            setSmplr(smplr)
          })
          .catch((error) => console.log(error))
    }, [])

    // Fetch and set space data after user is authenticated and smplrspace module has been loaded
    useEffect(() => {
        setShowSpace(false)
        const FetchSiteData = async () => {
            try {
            const headers = { "Authorization": "BEARER authToken=" + key, "Accept":"application/json" }    
            const siteData = await axios.get(`https://infinity.skyspark.nl/api/portal/eval?expr=inf_api_sites(@${siteId})`, {headers})
                // If request passes so no 403 but the returned sites are 0 user has no acces to site
                if(siteData['data']['rows'][0].length === 0) setNoSiteAccess(true)
                // Else set spacedata object
                else if(siteData['data']['rows'][0]['infSiteSmplrSpaceId']) {
                    const selectedSite = siteData['data']['rows'][0]
                    setSpaceData(spaceData => ({
                        ...spaceData,
                        spaceId : selectedSite['infSiteSmplrSpaceId'],
                        spaceCameraPosition : selectedSite['infSiteSmplrSpaceCameraPosition'],
                        spaceRefreshRate : selectedSite['infSiteSmplrSpaceRefreshRate']
                    }))
                    setShowSpace(true)
                }
            } catch (err) {
                // When an error occurs while fetching or setting buildingdata block viewer
                console.error(err)
                setAccessDenied(true)
            }
        }
        FetchSiteData()
    }, [key, siteId])

    // Set and start spaceviewer
    useEffect(() => {
        setViewerReady(false)
        // Clear space if space already exists
        if(spaceRef.current) spaceRef.current.remove()
        // When the smplrspace module has been loaded set space and start viewer
        if(smplr && showSpace) {
            spaceRef.current = new smplr.Space({
                spaceId: spaceData['spaceId'],
                clientToken: 'pub_3ee2a5233b354181a61c5e49691e7704',
                containerId: 'smplrviewer'
            })
            // Start the SmplrSpace viewer
            spaceRef.current.startViewer({
                preview: false,
                allowModeChange: true,
                mode: (viewType === "3D" || viewType === "2D")
                  ? viewType.toLowerCase()
                  : (console.error("Given url parameter for viewType == " + viewType + ", Is a invalid viewType"), undefined),
                onReady: () => {
                  console.log('Viewer ready')
                  setViewerReady(true)
                },
                onError: (e) => console.error('could not start viewer' + e),
                cameraPlacement: spaceData['spaceCameraPosition'],
                renderOptions: {
                  floorplan: {
                    render: true,
                    alpha: 1,
                    elevationInCm: 2
                  }
                }
            })
        }
    }, [smplr, spaceData, viewType, showSpace])
    
    useEffect(() => {
        const yeet = async () => {
        try {
          // if mapping starts and viewer is not started return 
          if (!viewerReady) return;
          const headers = { "Authorization": "BEARER authToken=" + key, "Accept":"application/json" }

          if(renderMode === "normal") {
            const assetMap = await axios.get(`https://infinity.skyspark.nl/api/portal/eval?expr=api_siteSmplrSpaceAssets(@${siteId})`, {headers})
            const rows = assetMap["data"]["rows"];

            rows.forEach(level => {
            // For garage doors
            if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Roldeuren'){
              if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                spaceRef.current.updateDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                        let xAngle = parseInt(dataElement['curVal'].val)
                        if(xAngle < 80) {
                          return "#57d147";
                        } else {
                          return "#FF0000"
                        }
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  height: 4.3,
                  alpha: 0.5
                })
              } else {
                spaceRef.current.addDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                        let xAngle = parseInt(dataElement['curVal'].val)
                        if(xAngle < 80) {
                          return "#57d147";
                        } else {
                          return "#FF0000"
                        }
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  height: 4.3,
                  alpha: 0.5
                })
              }
            }

            // For lights
            if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Lichtgroepen') {
              if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                spaceRef.current.updateDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                        let meetVal = parseInt(dataElement['curVal'].val)
                        if(meetVal > 10) {
                          return "#ffc90f";
                        } else {
                          return "#868686"
                        }
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  height: 4.3,
                  alpha: 0.5
                })
              } else {
                spaceRef.current.addDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if(dataElement['curVal'] !== undefined && dataElement['curVal'].val !== undefined){
                        let meetVal = parseInt(dataElement['curVal'].val)
                        if(meetVal > 10) {
                          return "#ffc90f";
                        } else {
                          return "#868686"
                        }
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  height: 4.3,
                  alpha: 0.5
                }) 
              } 
            }
            // For building installations
            if (level.type === 'polygon' && spaceRef.current !== null && level.name === "Gebouwinstalaties"){
              if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                spaceRef.current.updateDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  height: 3,
                  color: (dataElement) => {
                    try {
                      if(dataElement['name'].includes("Storing decimaal cur") && dataElement['curVal'] !== undefined) {
                        let value = parseInt(dataElement['curVal'])
                        if(value > 5) {
                          return "#FF0000";
                        } else {
                          return "#57d147";
                        }
                      } else if(dataElement['curValList'] !== undefined) {
                        if(dataElement['curValList'].find(row => row['unit'] === 'Pa') !== undefined) {
                          let value = parseInt(dataElement['curValList'].find(row => row['unit'] === 'Pa')['val'])
                          if(value > 20) {
                            return "#57d147";
                          } else {
                            return "#FF0000"
                          }
                        } else {
                          if(dataElement['curValList'][0]['val'] !== undefined) {
                            let value = parseInt(dataElement['curValList'][0]['val'])
                            if(value > 0) {
                              return "#57d147";
                            } else {
                              return "#FF0000"
                            }
                          } else {
                            let value = parseInt(dataElement['curValList'][0])
                            if(value > 0) {
                              return "#57d147";
                            } else {
                              return "#FF0000"
                            }
                          }
                        }
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  alpha: 0.5
                })
              } else {
                spaceRef.current.addDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  height: 3,
                  color: (dataElement) => {
                    try {
                      if(dataElement['name'].includes("Storing decimaal cur") && dataElement['curVal'] !== undefined) {
                        let value = parseInt(dataElement['curVal'])
                        if(value > 5) {
                          return "#FF0000";
                        } else {
                          return "#57d147";
                        }
                      } else if(dataElement['curValList'] !== undefined) {
                        if(dataElement['curValList'].find(row => row['unit'] === 'Pa') !== undefined) {
                          let value = parseInt(dataElement['curValList'].find(row => row['unit'] === 'Pa')['val'])
                          if(value > 20) {
                            return "#57d147";
                          } else {
                            return "#FF0000"
                          }
                        } else {
                          if(dataElement['curValList'][0]['val'] !== undefined) {
                            let value = parseInt(dataElement['curValList'][0]['val'])
                            if(value > 0) {
                              return "#57d147";
                            } else {
                              return "#FF0000"
                            }
                          } else {
                            let value = parseInt(dataElement['curValList'][0])
                            if(value > 0) {
                              return "#57d147";
                            } else {
                              return "#FF0000"
                            }
                          }
                        }
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  alpha: 0.5
                })
              }
            }
            // For normal rooms
            if (level.type === 'polygon' && spaceRef.current !== null && level.name !== 'Roldeuren' && level.name !== 'Lichtgroepen' && level.name !== "Gebouwinstalaties") {
              if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                spaceRef.current.updateDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if (dataElement.color) {
                        return dataElement.color;
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  alpha: 0.5
                });
              } else {
                spaceRef.current.addDataLayer({
                  id: level.id,
                  type: 'polygon',
                  data: level.assets,
                  tooltip: (d) => `${d.name}`,
                  color: (dataElement) => {
                    try {
                      if (dataElement.color) {
                        return dataElement.color;
                      } else {
                        return "#c7c7c7";
                      }
                    } catch (err) {
                      console.log(`${dataElement?.id} cant be coloured`)
                      return "#c7c7c7";
                    }
                  },
                  alpha: 0.5
                });
              }
            }
          })} else if (renderMode === "lightConsumption") {
            const assetMap = await axios.get(`https://infinity.skyspark.nl/api/portal/eval?expr=api_siteSmplrSpaceAssetsLightConsumption(@${siteId})`, {headers})
            const rows = assetMap['data']['rows']

            // Finding Max Turnons and door opens
            let lightGroupMaxTurnOns = Math.max(
              ...rows.find(row => row.name === "Lichtgroepen")?.assets.map(row => row.totalStarts) || []
            );
            let dockDoorsMaxOpens = Math.max(
              ...rows.find(row => row.name === "Roldeuren")?.assets.map(row => row.totalOpens) || []
            )

            // Color scales for heatmap colours
            const colorScaleLight = d3.scaleLinear()
            .domain([0, lightGroupMaxTurnOns])
            .range(["#ADD8E6", "#4B0082"]);
            const colorScaleDock = d3.scaleLinear()
            .domain([0, dockDoorsMaxOpens])
            .range(["#ADD8E6", "#4B0082"]);

            rows.forEach(level => {
              // For garage doors
              if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Roldeuren'){
                if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                  spaceRef.current.updateDataLayer({
                    id: level.id,
                    type: 'polygon',
                    data: level.assets,
                    tooltip: (d) => `${d.name}`,
                    color: (dataElement) => {
                      if(dataElement['totalOpens'] !== undefined){
                        let totalOpens = dataElement['totalOpens']
                        return colorScaleDock(totalOpens)
                      } else {
                        return "#c7c7c7";
                      }
                    },
                    height: 4.3,
                    alpha: 1
                  })
                } else {
                  spaceRef.current.addDataLayer({
                    id: level.id,
                    type: 'polygon',
                    data: level.assets,
                    tooltip: (d) => `${d.name}`,
                    color: (dataElement) => {
                      if(dataElement['totalOpens'] !== undefined){
                        let totalOpens = dataElement['totalOpens']
                        return colorScaleDock(totalOpens)
                      } else {
                        return "#c7c7c7";
                      }
                    },
                    height: 4.3,
                    alpha: 1
                  })
                }
              }
              // For lights
              if (level.type === 'polygon' && spaceRef.current !== null && level.name === 'Lichtgroepen') {
                if (spaceRef.current.getDataLayer(level.id) !== undefined) {
                  spaceRef.current.updateDataLayer({
                    id: level.id,
                    type: 'polygon',
                    data: level.assets,
                    tooltip: (d) => `${d.name}`,
                    color: (dataElement) => {
                      if(dataElement['totalStarts'] !== undefined){
                        let burnVal = parseInt(dataElement['totalStarts'])
                        return colorScaleLight(burnVal)
                      } else {
                        return "#c7c7c7";
                      }
                    },
                    height: 4.3,
                    alpha: 0.5
                  })
                } else {
                  spaceRef.current.addDataLayer({
                    id: level.id,
                    type: 'polygon',
                    data: level.assets,
                    tooltip: (d) => `${d.name}`,
                    color: (dataElement) => {
                      if(dataElement['totalStarts'] !== undefined){
                        let burnVal = parseInt(dataElement['totalStarts'])
                        return colorScaleLight(burnVal)
                      } else {
                        return "#c7c7c7";
                      }
                    },
                    height: 4.3,
                    alpha: 0.5
                  }) 
                } 
              }
            })
          }
        } catch {
          return;
        }
        }
        yeet()
        let intervalId;
        if(renderMode === "lightConsumption") intervalId = setInterval(yeet, 180000);
        else intervalId = setInterval(yeet, spaceData['spaceRefreshRate']);

        return () => clearInterval(intervalId);
      }, [viewerReady, spaceRef, siteId, key, renderMode, spaceData]);

    return (
        <Box>
            {
                showSpace ? (
                <Box sx={{width:'100vw', height:'100vh'}} id="smplrviewer"/>
                ) : (
                  noSiteAccess && (<Box sx={{width:'100vw', height:'100vh', display:'flex', alignItems:'center', justifyContent:'center'}}><Typography sx={{fontSize:'48px', color:'#747474'}}>GEEN TOEGANG TOT DIT GEBOUW</Typography></Box>),
                  accessDenied && (<Box sx={{width:'100vw', height:'100vh', display:'flex', alignItems:'center', justifyContent:'center'}}><Typography sx={{fontSize:'48px', color:'#747474'}}>ONVOLDOENDE RECHTEN</Typography></Box>)
                )
            }
        </Box>
    )
}

export default IFrameBuildingView